import pathHolder from '@/services/security/path-after-login.holder'
import userProfile from '@/services/security/user-profile.service'
import authService from '@/services/security/hosted-auth.service'
import router from '@/router'
import {restore} from '@/config/store'

export default function () {
  authService
    .addAuthenticatedHandler(() => restore())
    .addAuthenticatedHandler(() => {
      const pathAfterLogin = pathHolder.popPath()
      router.replace(pathAfterLogin)
    })

  authService.addBeforeLogoutHandler(() => {
    userProfile.reinitializeUserProperties()
  })
}
